// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 100%;
}
:host:not(:last-child) {
  margin-bottom: 10px;
}

h4 {
  margin-top: 0;
}

p {
  color: var(--ion-color-text-gery);
  font-weight: 500;
}

.order-item {
  width: 100%;
  border-bottom: 1px solid #ebdfda;
  padding-bottom: 20px;
  padding-right: 5px;
  padding-left: 0;
}
.order-item.eintracht {
  padding-top: 23px;
  border-bottom: none;
  border-top: 1px solid #383838;
}
.order-item.eintracht .quantity-regulator {
  border: none;
}
.order-item.eintracht .order-article-name, .order-item.eintracht .article-price {
  color: #ffffff;
  font-family: EintrachtDisplaySublineCondensed;
  font-size: 20px;
  line-height: 110%;
  font-weight: normal;
}
.order-item.eintracht .options-block p {
  font-family: AppFontEintrachtOFCSans;
  color: #D6D6D6;
  font-weight: 400;
}
.order-item .img_section {
  width: 24%;
  max-height: 100px;
  margin: 0 7px;
}
.order-item .img_section ion-img {
  object-fit: contain;
  width: 100%;
  height: auto;
  margin: 0;
}
.order-item ion-col {
  padding: 0px !important;
}

.tools {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.tools img {
  height: 15px;
  width: 15px;
}

.quantity-regulator {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 40px;
  padding: 5px;
  font-size: 20px;
  font-family: var(--ion-font-family);
  max-width: 135px;
}
.quantity-regulator .quantity-count {
  padding-top: 5px;
}

.article-price-block {
  display: flex;
  width: 16%;
  justify-content: flex-start;
  flex-direction: column;
  align-items: end;
}

.article-name-block {
  width: 60%;
}

.eintracht .article-name-block {
  width: 50%;
}
.eintracht .article-price-block {
  width: 26%;
}

.options-block .option-name-row {
  margin-bottom: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/order-list/order-list.component.scss"],"names":[],"mappings":"AAEA;EACC,cAAA;EACA,WAAA;AADD;AAEC;EACC,mBAAA;AAAF;;AAIA;EACC,aAAA;AADD;;AAIA;EACC,iCAAA;EACA,gBAAA;AADD;;AAIA;EACC,WAAA;EACA,gCAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;AADD;AAEC;EACC,iBAAA;EACA,mBAAA;EACA,6BAAA;AAAF;AAEE;EACC,YAAA;AAAH;AAEE;EACC,cAAA;EACA,6CAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAAH;AAGG;EACC,oCAAA;EACA,cAAA;EACA,gBAAA;AADJ;AAMC;EACC,UAAA;EACA,iBAAA;EACA,aAAA;AAJF;AAKE;EACC,mBAAA;EAGA,WAAA;EACA,YAAA;EACA,SAAA;AALH;AAQC;EACC,uBAAA;AANF;;AAUA;EACC,aAAA;EACA,8BAAA;EAEA,uBAAA;AARD;AAUC;EACC,YAAA;EACA,WAAA;AARF;;AAWA;EAEC,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,YAAA;EAEA,YAAA;EACA,eAAA;EACA,mCAAA;EACA,gBAAA;AAVD;AAWE;EACC,gBAAA;AATH;;AAYA;EACC,aAAA;EACA,UAAA;EAEA,2BAAA;EAEA,sBAAA;EACA,gBAAA;AAXD;;AAaA;EACC,UAAA;AAVD;;AAaC;EACC,UAAA;AAVF;AAYC;EACC,UAAA;AAVF;;AAcC;EACC,mBAAA;AAXF","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n\tdisplay: block;\n\twidth: 100%;\n\t&:not(:last-child) {\n\t\tmargin-bottom: 10px;\n\t}\n}\n\nh4 {\n\tmargin-top: 0;\n}\n\np {\n\tcolor: var(--ion-color-text-gery);\n\tfont-weight: 500;\n}\n\n.order-item {\n\twidth: 100%;\n\tborder-bottom: 1px solid #ebdfda;\n\tpadding-bottom: 20px;\n\tpadding-right: 5px;\n\tpadding-left: 0;\n\t&.eintracht {\n\t\tpadding-top: 23px;\n\t\tborder-bottom: none;\n\t\tborder-top: 1px solid #383838;\n\n\t\t.quantity-regulator {\n\t\t\tborder: none;\n\t\t}\n\t\t.order-article-name, .article-price {\n\t\t\tcolor: #ffffff;\n\t\t\tfont-family: EintrachtDisplaySublineCondensed;\n\t\t\tfont-size: 20px;\n\t\t\tline-height: 110%;\n\t\t\tfont-weight: normal;\n\t\t}\n\t\t.options-block {\n\t\t\tp {\n\t\t\t\tfont-family: AppFontEintrachtOFCSans;\n\t\t\t\tcolor: #D6D6D6;\n\t\t\t\tfont-weight: 400;\n\t\t\t}\n\t\t}\n\t}\n\n\t.img_section {\n\t\twidth: 24%;\n\t\tmax-height: 100px;\n\t\tmargin: 0 7px;\n\t\tion-img {\n\t\t\tobject-fit: contain;\n\t\t\t// width: 90%;\n\t\t\t// height: 90%;\n\t\t\twidth: 100%;\n\t\t\theight: auto;\n\t\t\tmargin: 0\n\t\t}\n\t}\n\tion-col {\n\t\tpadding: 0px !important;\n\t}\n}\n\n.tools {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\t// align-items: center;\n\talign-items: flex-start;\n\t// margin-top: 10px;\n\timg {\n\t\theight: 15px;\n\t\twidth: 15px;\n\t}\n}\n.quantity-regulator {\n\t// width: 50%;\n\tdisplay: flex;\n\tjustify-content: space-around;\n\talign-items: center;\n\theight: 40px;\n\t// margin-left: calc(24% + 14px);\n\tpadding: 5px;\n\tfont-size: 20px;\n\tfont-family: var(--ion-font-family);\n\tmax-width: 135px;\n\t\t.quantity-count {\n\t\t\tpadding-top: 5px;\n\t\t}\n}\n.article-price-block {\n\tdisplay: flex;\n\twidth: 16%;\n\t// justify-content: flex-end;\n\tjustify-content: flex-start;\n\n\tflex-direction: column;\n\talign-items: end;\n}\n.article-name-block {\n\twidth: 60%;\n}\n.eintracht {\n\t.article-name-block {\n\t\twidth: 50%;\n\t}\n\t.article-price-block {\n\t\twidth: 26%;\n\t}\n}\n.options-block {\n\t.option-name-row {\n\t\tmargin-bottom: 10px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
